import { render, staticRenderFns } from "./Rule_Pokdeng.vue?vue&type=template&id=1d06cfc6&scoped=true&"
import script from "./Rule_Pokdeng.vue?vue&type=script&lang=js&"
export * from "./Rule_Pokdeng.vue?vue&type=script&lang=js&"
import style0 from "./Rule_Pokdeng.vue?vue&type=style&index=0&id=1d06cfc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d06cfc6",
  null
  
)

export default component.exports